import { useEffect, useRef } from 'react';
import rrwebPlayer from 'rrweb-player';
import 'rrweb-player/dist/style.css';

// @rrweb/types is a transitive dep — use permissive alias to avoid resolution issues
// eslint-disable-next-line @typescript-eslint/no-explicit-any
type eventWithTime = any;

interface Props {
  replayUrl: string;
}

export function ReplayPlayer({ replayUrl }: Props) {
  const containerRef = useRef<HTMLDivElement>(null);
  const playerRef = useRef<rrwebPlayer | null>(null);

  useEffect(() => {
    if (!containerRef.current) return;
    let cancelled = false;

    (async () => {
      const res = await fetch(replayUrl, { credentials: 'include' });
      if (!res.ok) return;
      const chunks = (await res.json()) as Array<{ data: unknown; t: number }>;
      if (cancelled || !containerRef.current) return;

      // Reset container
      containerRef.current.innerHTML = '';

      const events = chunks.map((c) => c.data) as eventWithTime[];
      if (events.length < 2) {
        containerRef.current.innerHTML = '<div class="p-6 text-sm text-text-muted">Not enough replay data.</div>';
        return;
      }

      playerRef.current = new rrwebPlayer({
        target: containerRef.current,
        props: {
          events,
          autoPlay: false,
          showController: true,
          width: 1024,
          height: 600,
        },
      });
    })();

    return () => {
      cancelled = true;
      playerRef.current = null;
    };
  }, [replayUrl]);

  return (
    <div
      ref={containerRef}
      className="rounded-lg border border-border bg-bg-surface overflow-hidden"
      style={{ minHeight: 600 }}
    />
  );
}
